var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) { ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgEmptyContent = function SvgEmptyContent(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "calc(100vw - 20px)",
    style: {
      maxWidth: 675
    },
    fill: "none",
    viewBox: "0 0 675 310"
  }, props), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#empty-content_svg__a)"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#C7EAFB",
    d: "M46.17 196.83C48.57 75.5 142.75 27.3 257.47 57.25 307.53 70.32 357.73 68.5 401.93 43.9c110.2-61.24 225.8-32.55 283.67 152.93"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#E6F5FD",
    d: "M240.76 155.77a7.17 7.17 0 0 1-7.17-7.18V96.98c0-2.46-.65-4.87-1.9-6.98l-4.12-6.78a1.9 1.9 0 0 0-3.36.04l-3.73 6.63a39.6 39.6 0 0 1-4.42 6.28 4.84 4.84 0 0 0-1.33 3.28v3.1a8 8 0 0 1-5.2 7.55 25.53 25.53 0 0 0-4.12 1.95 4.77 4.77 0 0 0-2.36 4.07v10.39a4.14 4.14 0 0 1-4.17 4.1h-37a13.7 13.7 0 0 0-13.7 13.7v6.56a11.92 11.92 0 0 1-11.91 11.92H70.92a26.48 26.48 0 0 0-26.48 26.5v7.68h103.74v.09H343.2v-4.9a36.44 36.44 0 0 0-36.4-36.43l-66.03.04Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M780 152.62h-55.74a4.53 4.53 0 0 1-4.54-4.54v-3.69c0-1.87-.47-3.72-1.37-5.37l-3.18-5.84a7.82 7.82 0 0 0-6.84-4.06h-18.48a7.8 7.8 0 0 0-6.85 4.06l-3.18 5.84c-.9 1.65-1.37 3.5-1.37 5.38v2.18a4.54 4.54 0 0 1-4.54 4.54h-15.57a11.06 11.06 0 0 1-7.82-3.24l-14.4-14.41a10.49 10.49 0 0 0-7.44-3.08h-6.13a4.6 4.6 0 0 1-4.6-4.6V115.5a5 5 0 0 0-1.77-3.7 5.15 5.15 0 0 1-1.55-2.53l-5.54-21.17a2.32 2.32 0 0 0-4.5 0l-5.54 21.17a5.54 5.54 0 0 1-1.66 2.64 5.08 5.08 0 0 0-1.66 3.77v25.58a4.33 4.33 0 0 1-4.33 4.33h-17.9a4.14 4.14 0 0 1-4.13-4.14v-6.57a4.65 4.65 0 0 0-2.3-3.98 25.37 25.37 0 0 0-25.74-.11l-.26.16a4.57 4.57 0 0 0-2.3 3.97v28.6a7.18 7.18 0 0 1-7.16 7.18h-40.1a8.82 8.82 0 0 1-8.82-8.83v-19.24a12.49 12.49 0 0 0-7.62-11.5l-20.97-8.83a12.46 12.46 0 0 1-7.62-11.5 12.48 12.48 0 0 0-10.13-12.25l-54.94-.15-2.07 100.42 103.33-1.9v-.21L780 198.6v-46Z"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#C7EAFB",
    d: "M268.06 74.55a37.26 37.26 0 0 0 37.25-37.28 37.26 37.26 0 1 0-37.25 37.28Z",
    style: {
      mixBlendMode: "multiply"
    }
  }), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#CBEBF7",
    d: "M104.53 143.22a3.75 3.75 0 0 1-1.9 7.21l-25.4-4.18a38.3 38.3 0 0 1-24.25-14.5 7.06 7.06 0 0 0 3.86-6.31v-.08l47.7 17.86Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M56.88 125.36v.08a7.07 7.07 0 0 1-10.55 6.14l-1.15.95L7.06 164a3.73 3.73 0 0 1-5.27-5.25l16.3-19.95a38.32 38.32 0 0 1 24.69-13.74 7.08 7.08 0 0 1 14.14.27l-.04.03Z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "m54.87 166.92.41 29.92H44.02l.4-29.92c.15-11.04.75-22.06 1.8-33.04l-1.07-1.32 1.16-.95c1.05.61 2.25.94 3.47.95 1.12 0 2.22-.27 3.22-.78.35.46.7.9 1.07 1.32l-.95.8a414.32 414.32 0 0 1 1.75 33.02Zm-.84-75.68a38.43 38.43 0 0 1-.44 28.26 7.06 7.06 0 0 0-7.46-.14l-8.41-50.29a3.75 3.75 0 0 1 7.2-1.9l9.1 24.07Z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    stroke: "#00AEEF",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 1.82,
    d: "M53 131.75a7.03 7.03 0 0 1-6.67-.13m7.3-12.12a7.05 7.05 0 0 1 3.25 5.86m0 0v.09a7.09 7.09 0 0 1-3.86 6.3m.61-12.25a7.04 7.04 0 0 0-7.46-.14m-3.46 5.72a7.06 7.06 0 0 1 3.46-5.73"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    stroke: "#00AEEF",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 1.82,
    d: "M53.62 119.5a38.46 38.46 0 0 0 .44-28.26l-9.1-24.1a3.75 3.75 0 0 0-7.2 1.9l8.41 50.28m-3.46 5.76a38.4 38.4 0 0 0-24.68 13.75L1.72 158.77a3.75 3.75 0 0 0 5.27 5.27l39.32-32.42m10.57-6.26 47.65 17.86a3.74 3.74 0 0 1-1.9 7.2l-25.42-4.16a38.41 38.41 0 0 1-24.23-14.5m.09 2.12a398.3 398.3 0 0 1 1.81 33.03l.4 29.92h35.17m-44.22-62.95a398.3 398.3 0 0 0-1.81 33.03l-.4 29.92H5.62"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fill: "#E3E1D8",
    d: "M550.75 213.28H425.9a8.46 8.46 0 0 0-8.48 8.48 8.49 8.49 0 0 1-8.48 8.47h-18.63v29.9h65.4a16.3 16.3 0 0 0 16.33-16.34 16.33 16.33 0 0 1 16.32-16.34h62.39a7.08 7.08 0 1 0 0-14.17Z"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    fill: "#44C8F5",
    d: "M555.52 162.47a12.3 12.3 0 0 0-4.98-8.03 12.9 12.9 0 0 1-4.85-7.36 12.57 12.57 0 0 0-3.44-5.99 7.62 7.62 0 1 0-14.13-2.37 12.61 12.61 0 0 0-7.14 9.85 14.72 14.72 0 0 1-3.6 8.21 16.43 16.43 0 0 0 4.26 25.57 12.4 12.4 0 0 1 5.47 6.53 12.61 12.61 0 0 0 24.05-7.36 11.25 11.25 0 0 1 1.91-9.54 12.3 12.3 0 0 0 2.45-9.5Z"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    stroke: "#00AEEF",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 1.82,
    d: "M550.85 188.27c.72-2.19.83-4.53.32-6.77a11.25 11.25 0 0 1 1.9-9.54 12.3 12.3 0 0 0-2.53-17.52 12.9 12.9 0 0 1-4.85-7.36 12.56 12.56 0 0 0-3.44-5.99 7.63 7.63 0 1 0-14.13-2.37m-7.12 9.83a14.71 14.71 0 0 1-3.6 8.21 16.43 16.43 0 0 0 4.26 25.58 12.39 12.39 0 0 1 5.47 6.52 12.58 12.58 0 0 0 10.18 7.98m-.02-18.07v41.6m0-13.17c0-5.26-6.58-6.2-6.58-6.2"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fill: "#C7EAFB",
    d: "M522.5 182.49a10.3 10.3 0 0 0-5.26-9 11.22 11.22 0 0 0-2.56-17.42 7.04 7.04 0 0 1-3.54-4.77c0-.17-.07-.35-.1-.53a8.43 8.43 0 0 0-9.54-6.28 8.31 8.31 0 0 0-6.36 11.15 7.04 7.04 0 0 1-.4 6.16 10.3 10.3 0 0 0-1.44 6.46 9.26 9.26 0 0 0-4.28 17.77 11.27 11.27 0 0 0 3.87 11.02 4.7 4.7 0 0 1 1.8 4.19 8.31 8.31 0 1 0 16.55 1.66c.09-1.54.71-3 1.77-4.14a5.51 5.51 0 0 0 .95-6.06 10.31 10.31 0 0 0 8.55-10.21Z"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    stroke: "#00AEEF",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 1.82,
    d: "M483.57 175.42a9.26 9.26 0 0 0 5.44 10.5 11.26 11.26 0 0 0 3.87 11.02 4.69 4.69 0 0 1 1.8 4.18 8.31 8.31 0 1 0 16.55 1.67 6.64 6.64 0 0 1 1.77-4.15 5.5 5.5 0 0 0 .95-6.05 10.3 10.3 0 0 0 3.3-19.17A11.24 11.24 0 0 0 514.7 156a7.02 7.02 0 0 1-3.54-4.77c0-.17-.07-.35-.1-.52a8.43 8.43 0 0 0-9.54-6.29 8.33 8.33 0 0 0-6.36 11.15 7.04 7.04 0 0 1-.4 6.16m8.17 37.62v21.02"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    fill: "#E3E1D8",
    d: "M51.97 294.16h326.72v15.74H40.45v-4.21a11.52 11.52 0 0 1 11.52-11.53Z"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    stroke: "#fff",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 2.11,
    d: "M285.8 92.91a7.84 7.84 0 0 0-13.43-.27 7.85 7.85 0 0 0-13.44.27"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    stroke: "#fff",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 1.05,
    d: "M299.14 105.44a3.93 3.93 0 0 0-6.71-.13 3.94 3.94 0 0 0-6.67.13"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    fill: "#ABE1FA",
    d: "M290.02 293.07c8.26-23.99 22.81-32.1 34.54-34.45 11.3-2.27 20.85-8.72 26.06-17.45 29.2-48.96 93.94-22.43 106.73 51.9"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    fill: "#44C8F5",
    d: "M524.2 251.03a18.85 18.85 0 0 0-5.94-13.39 19.06 19.06 0 0 0-10.3-5l-.5-.06a29.7 29.7 0 0 1-17.66-8.86 27.42 27.42 0 0 0-43.79 6.5 15.44 15.44 0 0 1-10.19 8.07 13.43 13.43 0 0 0-10.57 12.79"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    stroke: "#00AEEF",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 1.82,
    d: "M524.2 251.03a18.85 18.85 0 0 0-5.94-13.39 19.06 19.06 0 0 0-10.3-5l-.5-.06a29.7 29.7 0 0 1-17.66-8.86 27.42 27.42 0 0 0-43.79 6.5 15.44 15.44 0 0 1-10.19 8.07 13.43 13.43 0 0 0-10.57 12.79"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M325.45 294.16h204.47v-43.39H376.07v14.37l-25.31.14v14.38l-25.31.13v14.37Z"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    stroke: "#00AEEF",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 1.82,
    d: "M499.19 250.77H376.07v14.37m0 .13h-25.31v14.38m13.35.14h-38.66v14.37h-59.7"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M457.4 207.95a9.9 9.9 0 0 0-5.93-7.42l-7.85-3.28a3.7 3.7 0 0 1-2.24-4.2l.95-4.49.77-.3a2.09 2.09 0 0 0 1.32-1.9v-.12a2.03 2.03 0 0 0-.8-1.53l.45-.66c.55-.81.91-1.74 1.06-2.72l.1-.71a6.4 6.4 0 0 0-4.09-6.98 18.17 18.17 0 0 0-12.86-.08l-.88.33a3.58 3.58 0 0 0-2.33 3.06v.56a3.56 3.56 0 0 0 1.4 2.86c-.23 3.29.12 6.59 1.04 9.75a7.44 7.44 0 0 0 3.6 4.6l-.6.2-7.98 2.6a14.07 14.07 0 0 0-9.25 9.85l-4 15.38a8.65 8.65 0 0 0 .3 5.33l1.7 4.41c.48 1.26.67 2.61.54 3.95l-.43 4.65h35.73l.38-10.49 6.07 1.17a5.72 5.72 0 0 0 6.67-6.48l-2.85-17.34Z"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    stroke: "#00AEEF",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 1.82,
    d: "M446.66 241.05h-35.7l.43-4.66a8.74 8.74 0 0 0-.54-3.94l-1.7-4.42a8.67 8.67 0 0 1-.3-5.34l3.99-15.37a14.07 14.07 0 0 1 9.26-9.84l12.22-3.94"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    fill: "#6DCFF6",
    d: "m437.9 294.16-.96-5.14c-.4-2.17-.26-4.41.44-6.51l11.7-35.37-9.94-8.95-5.26 3.75-6.38 34.2a5.95 5.95 0 0 0 .32 3.3l.17.43a6.03 6.03 0 0 1-.56 5.5 6.18 6.18 0 0 0-.87 2.13l-1.3 6.68"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    stroke: "#00AEEF",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 1.82,
    d: "m437.9 294.16-.96-5.14c-.4-2.17-.26-4.41.44-6.51l11.7-35.37-9.94-8.95-5.26 3.75-6.38 34.2a5.95 5.95 0 0 0 .32 3.3l.17.43a6.03 6.03 0 0 1-.56 5.5v0a6.18 6.18 0 0 0-.87 2.13l-1.3 6.68m21.7-77.45 5 1.3"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    fill: "#C7EAFB",
    d: "m432.83 208.05-19.3 5.01 12.21 26.3 19.3-5-12.2-26.3Z"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    fill: "#C7EAFB",
    stroke: "#00AEEF",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 1.82,
    d: "M419.18 250.75h6.31c4.11 0 8.12-1.3 11.44-3.7l3.14-2.3 10.33 21.78a2.45 2.45 0 0 0 2.77 1.34 2.44 2.44 0 0 1 2.91 1.75l.52 1.98 2.26 8.85 8.83-2.36a3.9 3.9 0 0 0 1.15-6.99l-2.04-1.28a10.69 10.69 0 0 1-4.12-5.16l-10.75-28.61a12.8 12.8 0 0 0-2.73-4.35 15.1 15.1 0 0 0-2.03-1.25 75.8 75.8 0 0 1-2.13-1.67 12.77 12.77 0 0 0-11.1.37l-22.98 11.96-.06.96a8.3 8.3 0 0 0 8.28 8.68Z"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    fill: "#FEDFC5",
    stroke: "#00AEEF",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 1.82,
    d: "m440.31 214.96-4.86-2.13.16.63a1.5 1.5 0 0 1-1.03 1.8c-.24.08-.5.1-.75.04l-4.06-.81a1.91 1.91 0 0 0-2.25 1.66 1.9 1.9 0 0 0 .83 1.75l1.9 1.31 1.44 2.45a3.75 3.75 0 0 0 3.57 1.84l5.01-.47.04-8.07Zm-22.78 13.93v8.82l5.03-1.17a6.06 6.06 0 0 0 4.24-3.62l1.03-2.52a3.06 3.06 0 0 0-1.28-3.77 3.03 3.03 0 0 0-2.64-.21l-6.38 2.47Z"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    fill: "#FEDFC5",
    d: "M440.73 173.6a18.18 18.18 0 0 0-12.86-.08l-.88.32a3.57 3.57 0 0 0-2.32 3.06v.28a3.6 3.6 0 0 0 1.4 3.14l1.67 11.88a2.87 2.87 0 0 0 2.35 2.5l.19 4.31 2.37 2.62a4.11 4.11 0 0 0 5.36.59c.86-.6 1.45-1.5 1.66-2.53l2.85-14 1.15-1.69c.55-.8.9-1.73 1.05-2.7l.1-.73a6.46 6.46 0 0 0-4.09-6.98Z"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    fill: "#E3E1D8",
    d: "M440.73 173.6a18.18 18.18 0 0 0-12.86-.08l-.88.32a3.57 3.57 0 0 0-2.32 3.06v.28a3.6 3.6 0 0 0 1.4 3.14l2.47.47c1.99.38 4.02.4 6.02.06l1.55-.27a1.44 1.44 0 0 1 1.66 1.25l.39 3.52.95.95 1.83-1.9.33-.1a2.06 2.06 0 0 1 1.9.35l.46-.66c.55-.82.9-1.74 1.05-2.71l.1-.73a6.46 6.46 0 0 0-4.05-6.96Z"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    stroke: "#00AEEF",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 1.82,
    d: "m430.06 194.7.14 3.28a4.8 4.8 0 0 0 1.68 3.42"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    stroke: "#00AEEF",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 1.82,
    d: "M433.75 195.33c-2.33 0-5.17-.87-6.67-5.26a28 28 0 0 1-1.04-9.75v0a3.6 3.6 0 0 1-1.4-3.14v-.28a3.58 3.58 0 0 1 2.32-3.06l.88-.32a18.18 18.18 0 0 1 12.86.07v0a6.45 6.45 0 0 1 4.1 6.98l-.11.73c-.14.97-.5 1.9-1.05 2.7l-1.14 1.7-1.52 7.35a3.73 3.73 0 0 0 2.23 4.2l2.03.84"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    stroke: "#00AEEF",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 1.37,
    d: "M439.12 186.34a4.02 4.02 0 0 1-1.14-2.37l-.24-2.14a1.44 1.44 0 0 0-1.66-1.25l-2.42.41c-1.4.25-2.85.16-4.22-.25"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    fill: "#FEDFC5",
    d: "m440.94 184.41.33-.1a2.1 2.1 0 0 1 2.4 3.15 2.1 2.1 0 0 1-.98.83l-2.01.8"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    stroke: "#00AEEF",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 1.82,
    d: "m440.94 184.41.33-.1a2.1 2.1 0 0 1 2.73 1.9v0a2.1 2.1 0 0 1-1.31 2.08l-2.01.8"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    stroke: "#00AEEF",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 0.91,
    d: "m430.03 184.6-1.33.22m6.09.24 1.39.46m-2.43 5.92-.56.06c-.66.07-1.32.03-1.97-.13m1.61-2.04-.16.04a.81.81 0 0 1-.65-.05l-.17-.08a.63.63 0 0 1-.24-.8l.12-.23m3.32-1.86v.21m-5.35-.63v.21"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    stroke: "#00AEEF",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 1.82,
    d: "m453.14 267.89 6.97-1.72m-16.87-68.91 7.86 3.27a9.91 9.91 0 0 1 5.92 7.4l3.09 17.58a5.72 5.72 0 0 1-6.42 6.6l-3.22-.43a8.03 8.03 0 0 1-4.94-2.74v0a8.1 8.1 0 0 0-2.59-2.03v0a4.76 4.76 0 0 1-2.63-4.26v-7.67l6.62 1.78.51-7.8m41.06 41.81h50.7m-113.96 43.39H364.1m110.62 0h-36.67"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    stroke: "#00AEEF",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 0.91,
    d: "m458.15 277.78 7.23-2.02m-39.61 15.68h7.42"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    fill: "#6DCFF6",
    d: "m547.27 29.53-15.8-16.73 4.26-1.05a8.69 8.69 0 0 1 6.67 1.08l20.36 12.89"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    stroke: "#00AEEF",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 1.86,
    d: "m547.27 29.53-15.8-16.73 4.26-1.05a8.69 8.69 0 0 1 6.67 1.08l20.36 12.89"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "m518.3 33.35 98.09-24.13c2.88-.7 5.9-.58 8.72.37l2.21.74a5.17 5.17 0 0 1 2.36 8.17 15.64 15.64 0 0 1-8.41 5.34L552 40.87a107.19 107.19 0 0 1-44.15 1.47l-11.27-2-13.03-15.38 4.72-1.16a9.61 9.61 0 0 1 7.46 1.25l9.53 6.12a16.7 16.7 0 0 0 13.03 2.18Z"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    stroke: "#00AEEF",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 1.86,
    d: "m518.3 33.35 98.09-24.13c2.88-.7 5.9-.58 8.72.37l2.21.74a5.17 5.17 0 0 1 2.36 8.17 15.64 15.64 0 0 1-8.41 5.34L552 40.87a107.19 107.19 0 0 1-44.15 1.47l-11.27-2-13.03-15.38 4.72-1.16a9.61 9.61 0 0 1 7.46 1.25l9.53 6.12a16.7 16.7 0 0 0 13.03 2.18v0Z"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "m496.64 39.07-3.99 8.67 3.49-.85a7.99 7.99 0 0 0 4.55-3.06l5.07-7"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    stroke: "#00AEEF",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 1.86,
    d: "m496.64 39.07-3.99 8.67 3.49-.85a7.99 7.99 0 0 0 4.55-3.06l5.07-7"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    fill: "#6DCFF6",
    d: "m544.64 40.17 19.87-4.88a2.57 2.57 0 0 1 3.11 1.88l.48 1.93a2.58 2.58 0 0 1-1.89 3.11l-19.87 4.89-1.7-6.96v.03Z"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "m549.25 37.54-6.29 22.14 4.26-1.04a8.76 8.76 0 0 0 5.44-4.08l12.08-20.82"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    stroke: "#00AEEF",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 1.86,
    d: "m549.25 37.54-6.29 22.14 4.26-1.04a8.76 8.76 0 0 0 5.44-4.08l12.08-20.82"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    fill: "#CBEBF7",
    d: "m621.34 9.6-1.72 1.7a2.19 2.19 0 0 0-.56 2.05 2.16 2.16 0 0 0 2.6 1.57l1.54-.37a7.5 7.5 0 0 0 4.15-2.7l.38-.5-3.7-1.27-2.7-.49Zm-50.37 15.88-5.13 1.26a1.58 1.58 0 0 0-1.16 1.92l.23.94c.2.85 1.07 1.37 1.91 1.16l5.14-1.26a1.58 1.58 0 0 0 1.16-1.92l-.23-.94a1.58 1.58 0 0 0-1.92-1.16Zm10.78-2.65-5.14 1.26a1.58 1.58 0 0 0-1.15 1.92l.23.94c.2.85 1.06 1.37 1.91 1.16l5.14-1.26a1.58 1.58 0 0 0 1.16-1.91l-.24-.95a1.58 1.58 0 0 0-1.9-1.16Zm10.77-2.65-5.14 1.27a1.58 1.58 0 0 0-1.16 1.91l.24.95c.2.84 1.06 1.36 1.91 1.16l5.14-1.27a1.58 1.58 0 0 0 1.15-1.91l-.23-.95a1.58 1.58 0 0 0-1.91-1.16Zm10.78-2.66-5.14 1.27A1.58 1.58 0 0 0 597 20.7l.24.95c.2.84 1.06 1.36 1.9 1.16l5.14-1.27a1.58 1.58 0 0 0 1.16-1.91l-.23-.95a1.58 1.58 0 0 0-1.91-1.16Zm10.78-2.65-5.14 1.27a1.58 1.58 0 0 0-1.16 1.91l.23.95c.21.85 1.07 1.36 1.92 1.16l5.13-1.27a1.58 1.58 0 0 0 1.16-1.91l-.23-.95a1.58 1.58 0 0 0-1.91-1.16Z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "empty-content_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h780v309.89H0z"
  })))));
};
export default SvgEmptyContent;